import { render, staticRenderFns } from "./TroubleshootingIndex.vue?vue&type=template&id=538218c6"
import script from "./TroubleshootingIndex.vue?vue&type=script&lang=js"
export * from "./TroubleshootingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports